<div class="overlay" *ngIf="showErrorMessageModal">
    <div class="overlay-content">
        <div class="d-flex flex-column error-overlay-details">
            <div class="d-flex flex-column align-items-start">
                <div class="d-flex justify-content-start align-items-center pb-3">
                    <img [src]="imageSrc" class="icon">
                    <div class="error-title pl-2">{{ errorTitle }}</div>
                </div>
                <div class="max-limit-error-text">{{ errorSummary }}</div>
                <button class="error-modal-primary-button" (click)="handlePrimaryCtaClick()">{{primaryCtaText}}</button>
                <button class="error-modal-secondary-button" (click)="handleSecondaryCtaClick()">{{secondaryCtaText}}</button>
            </div>
        </div>
    </div>
</div>
